import * as service from "../service";
import { store } from "../../store";
import type { ServiceResponse } from "../types";

export type RedeemSponsorType = "personal" | "society";

export type RedeemSponsorExtra = {
  activityName?: string;
  activityDate?: string;
  signedAgreement?: string;
  officialIG?: string;
  committeeIGs?: string[];
  society_id?: string;
  participantsQuantity?: number;
  quantity?: number;
  taskIds?: string[];
};

export type RedeemSponsorResult = {
  completions?: any[];
  sponsorActivity?: any;
};

/**
 * Redeem a sponsor activity for the current student, either personally or on
 * behalf of a society.
 * Backend: POST /api/sponsor/redeemSponsor
 */
export const RedeemSponsorAPI = async (
  sponsor_id: string,
  type?: string,
  extra?: RedeemSponsorExtra,
): Promise<ServiceResponse<RedeemSponsorResult>> => {
  const { student } = store.getState().auth as any;
  try {
    const payload: any = {
      sponsor_id,
      student_id: student?.id,
    };
    if (type) payload.type = type;
    if (extra) {
      if (extra.activityName) payload.activityName = extra.activityName;
      if (extra.activityDate) payload.activityDate = extra.activityDate;
      if (extra.signedAgreement) payload.signedAgreement = extra.signedAgreement;
      if (extra.officialIG) payload.officialIG = extra.officialIG;
      if (extra.committeeIGs) payload.committeeIGs = extra.committeeIGs;
      if (extra.society_id) payload.society_id = extra.society_id;
      if (extra.participantsQuantity)
        payload.participants_quantity = extra.participantsQuantity;
      if (extra.quantity) payload.quantity = extra.quantity;
      // Explicit selection, including an empty array. Leave it absent when the
      // caller has no selection so the server keeps its all-available default.
      if (extra.taskIds !== undefined) payload.task_ids = extra.taskIds;
    }
    const resp = await service.call(
      "POST",
      "api/sponsor/redeemSponsor",
      payload,
    );
    return resp as ServiceResponse<RedeemSponsorResult>;
  } catch (err) {
    console.error(`RedeemSponsorAPI ${err}`);
    return { status: -1, error: err };
  }
};
